import React from 'react'
import { Formik, Form } from 'formik'
import { validateForgotPasswordForm } from './validation'
import { Card } from 'app/components/ui/Card'
import { Text } from 'app/components/ui/Text'
import { Button } from 'app/components/ui/Button'
import styled from 'styled-components'
import { SmartInput } from 'app/components/formik/Input'
import { GetDataError } from 'restful-react'
import { ApiError } from 'EstraSuppliers'
import { ApiErrorMessage } from 'app/components/ui/form/ApiErrorMessage'
import { Title } from 'app/components/ui/Title'
import { themeEstra } from 'app/styles/themeEstra'

const initialValues = {
  email: '',
}

export type ForgotPasswordFormValues = {
  email: string
}

interface Props {
  onForgotPasswordRequest: (
    email: string,
    setSubmitting: (isSubmitting: boolean) => void
  ) => void
  isLoading: boolean
  showConfirmation: boolean
  error?: GetDataError<ApiError> | null
}
export const FormForgotPassword: React.FC<Props> = ({
  onForgotPasswordRequest,
  isLoading,
  showConfirmation,
  error,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validate={validateForgotPasswordForm}
      onSubmit={({ email }, { setSubmitting }) => {
        onForgotPasswordRequest(email, setSubmitting)
      }}
    >
      {() => {
        return (
          <Form>
            <Card shadow padding='2rem'>
              {showConfirmation ? (
                <>
                  <ConfirmationTitle size={4}>
                    Controlla il tuo indirizzo email
                  </ConfirmationTitle>
                  <Text mb={1}>
                    Ti abbiamo inviato le istruzioni per procedere al reset
                    della password.
                  </Text>
                </>
              ) : (
                <>
                  <InputGroup>
                    <SmartInput
                      label='Email'
                      name='email'
                      type='email'
                      bgColor={themeEstra.color.neutri.grigioBg}
                    />
                  </InputGroup>
                  <ButtonWrapper>
                    {error && (
                      <ForgotPasswordApiErrorMessage
                        outline
                        error={error}
                      ></ForgotPasswordApiErrorMessage>
                    )}
                    <Button type='submit' disabled={isLoading}>
                      Azzera Password
                    </Button>
                  </ButtonWrapper>
                </>
              )}
            </Card>
          </Form>
        )
      }}
    </Formik>
  )
}

const InputGroup = styled.div`
  margin-bottom: 2rem;
`

const ButtonWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ForgotPasswordApiErrorMessage = styled(ApiErrorMessage)`
  margin-bottom: 1rem;
`

const ConfirmationTitle = styled(Title)`
  margin-bottom: 1rem;
`
